import React from 'react'
import withServices from '../../hocs/withServices'
import { Button, Container, Grid, MenuItem, TextField, Typography } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form';
import fileDownload from 'js-file-download';
import { useAlert } from '../../hooks/useAlert';

const CustomCard = ({ services }) => {
    const {
        handleSubmit,
        control,
        watch,
        formState: { errors },
        
    } = useForm();

    const showAlert = useAlert();


    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}.${month}.${year}`;
    };

    const onSubmit = (data) => {
        const formData = new FormData();

        formData.append('role', data.role)
        formData.append('surname', data.surname)
        formData.append('name', data.name)
        formData.append('barcode', data.barcode)
        formData.append('validDate', data.validDate ? formatDate(data.validDate) : "")
        formData.append('photo', data.photo)

        services.idCard.createCustomCard(formData)
            .then((response) => {
                const contentDisposition = response.headers["content-disposition"];
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                const filename =
                    matches && matches[1] ? matches[1].replace(/['"]/g, "") : "image.png";

                fileDownload(response.data, filename);
                showAlert('Карточка успешно сгенерирована!', 'success');
            })
            .catch(() => {
                showAlert('Ошибка на сервере!', 'error');
            });
    }

    return (
        <Container component="main" maxWidth="xl">
            <Typography variant="h4">Создание карточек</Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container justify='center' spacing={2} style={{ marginTop: "20px" }}>
                    <Grid item xs={12} md={8} lg={10}>
                        <Controller
                            name="role"
                            control={control}
                            defaultValue=""
                            render={({ field }) =>
                                <TextField
                                    select
                                    {...field}
                                    variant="outlined"
                                    fullWidth
                                    label="Роль"
                                >
                                    <MenuItem value={"STUDENT"}>Студент</MenuItem>
                                    <MenuItem value={"OFFICE"}>Офис</MenuItem>
                                    <MenuItem value={"TEACHER"}>Учитель</MenuItem>
                                </TextField>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={8} lg={10}>
                        <Controller
                            name="surname"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value }, fieldState: { error } }) =>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label='Фамилия'
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/[^A-Za-z]/gi, "");
                                        onChange(value);
                                    }}
                                    value={value}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={8} lg={10}>
                        <Controller
                            name="name"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value }, fieldState: { error } }) =>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    label='Имя'
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/[^A-Za-z]/gi, "");
                                        onChange(value);
                                    }}
                                    value={value}
                                />
                            }
                        />
                    </Grid>
                    {watch("role") === "STUDENT" && (<>
                        <Grid item xs={12} md={8} lg={10}>
                            <Controller
                                name="barcode"
                                control={control}
                                defaultValue=""
                                render={({ field }) =>
                                    <TextField
                                        {...field}
                                        variant="outlined"
                                        fullWidth
                                        margin="normal"
                                        label="Баркод"
                                        inputProps={{ maxLength: 6, pattern: "[0-9]{6}" }}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={8} lg={10}>
                            <Controller
                                name="validDate"
                                control={control}
                                defaultValue=""
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <TextField
                                        value={value || ""}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        type="date"
                                        helperText="Дата"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        error={!!error}
                                    />
                                )}
                            />
                        </Grid>
                    </>)}
                    <Grid item xs={12} md={8} lg={10}>
                        <Controller
                            name="photo"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <Button
                                    variant="contained"
                                    component="label"
                                    fullWidth
                                >
                                    Загрузить фото
                                    <input
                                        type="file"
                                        onChange={(event) => { onChange(event.target.files[0]) }}
                                        hidden
                                    />
                                </Button>
                            )}
                        />
                        {watch("photo") && <p>{watch("photo").name}</p>}
                        {errors.photo && <p>{errors.photo.message}</p>}
                    </Grid>
                    <Grid item xs={12} md={8} lg={10}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                        >
                            Сохранить
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
}

export default withServices()(CustomCard)